import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Path } from 'components/_hooks/use-router';
import { Logo } from 'components/UI/logo/logo';
import styles from '../_auth.module.scss';

const AuthHeader: React.FC = () => {
  return (
    <div className={styles.Header}>
      <Link to={Path.root}>
        <Logo />
      </Link>
      <div className={styles.HeaderNavigation}>
        <NavLink activeClassName={styles.active} to={Path.login}>
          Sign In
        </NavLink>
        <NavLink activeClassName={styles.active} to={Path.register}>
          Sign Up
        </NavLink>
      </div>
    </div>
  );
};

export { AuthHeader };
